import accidentInsurance from './accident-insurance';
import leave from './leave';

export default [
  ...accidentInsurance,
  ...leave,
];
